<div
  (click)="onTitleClick($event)"
  [ngClass]="active ? 'opacity-100 block' : 'py-5 px-3.5 opacity-0 hidden'"
>
  <ng-content></ng-content>
</div>
